'use strict';

function throttle(callback, wait, options) {
  if (options === void 0) {
    options = {};
  }

  var leading = options.leading !== false;
  var isWait = false;
  var args;
  var pending;
  var leadingCalled;
  return function () {
    args = arguments;

    if (leading) {
      if (!leadingCalled) {
        callback.apply(null, args);
        leadingCalled = true;
        args = [];
        window.setTimeout(function () {
          if (pending) {
            callback.apply(null, args);
            pending = false;
          }

          leadingCalled = false;
        }, wait);
      } else {
        pending = true;
      }
    } else if (!isWait) {
      window.setTimeout(function () {
        callback.apply(null, args);
        isWait = false;
      }, wait);
      isWait = true;
    }
  };
}

function debounce(callback, wait) {
  var timer;
  return function () {
    var args = arguments;

    if (timer) {
      window.clearTimeout(timer);
    }

    timer = window.setTimeout(function () {
      callback.apply(null, args);
    }, wait);
  };
}

module.exports = {
  throttle: throttle,
  debounce: debounce
};
//# sourceMappingURL=timeUtils.js.map